import Bouncer from 'formbouncerjs';

type ErrorMessageResponse = {
  success: boolean;
  message: string;
  errors: Record<string, string>;
}

/**
 * Force submissions to target the internal API for always rendering an error message on submission.
 */
export const enableAlwaysErrorMode = (formDiv : Element) => {
  const enabledAttribute = formDiv.getAttribute('data-always-error-mode') === 'true';
  if(!enabledAttribute) {
    return;
  }

  // Change the action to the internal API
  const form = formDiv.querySelector('form');
  if(!form) {
    return;
  }

  const actionUrl = '/wp-json/forms/v1/dev-modes/error-response';
  form.setAttribute('action', actionUrl);
}

/**
 * Render the global error message, which is the first error message in the form.
 */
export const renderGlobalErrorMessage = (formDiv: Element, errorResponse: ErrorMessageResponse) => {
  let globalErrorDiv = formDiv.querySelector('.form-error');

  // Create the global error div if it doesn't exist
  if (!globalErrorDiv) {
    globalErrorDiv = document.createElement('div');
    globalErrorDiv.className = 'form-error';
    formDiv.prepend(globalErrorDiv);
  }

  // Clear any existing error messages
  globalErrorDiv.innerHTML = '';

  const errorElement = document.createElement('div');
  errorElement.className = 'error-message';
  errorElement.textContent = errorResponse.message;

  globalErrorDiv.appendChild(errorElement);
}
